import React, { Fragment } from 'react';
import styled from 'styled-components';

import useTranslation from 'hooks/use-translation';

function addProperGrammarToEstimate(t, estimate) {
  // eslint-disable-next-line i18next/no-literal-string
  if (['today', 'tomorrow'].every((str) => !estimate.includes(str))) {
    return t('closedBut.estimate-date', { defaultValue: 'on {{estimate}}', estimate });
  }
  return t('closedBut.estimate-day', { defaultValue: '{{estimate}}', estimate });
}

function PickupAndDelivery({ pickupEstimate, deliveryEstimate }) {
  const { Trans } = useTranslation();
  return (
    <Trans i18nKey='closedBut.pickup-and-delivery'>
      Orders can be <b>picked up</b> {{ pickupEstimate }}, or <b>delivered</b> {{ deliveryEstimate }}.
    </Trans>
  );
}
function OnlyDelivery({ deliveryEstimate }) {
  const { Trans } = useTranslation();
  return (
    <Trans i18nKey='closedBut.delivery-only'>
      Orders can be <b>delivered</b> {{ deliveryEstimate }}.
    </Trans>
  );
}
function OnlyPickup({ pickupEstimate }) {
  const { Trans } = useTranslation();
  return (
    <Trans i18nKey='closedBut.pickup-only'>
      Orders can be <b>picked up</b> {{ pickupEstimate }}.
    </Trans>
  );
}

export default function ClosedButInfo(props) {
  const { formattedPickupEstimate, formattedDeliveryEstimate, storeHoursDeliveryOnly } = props;
  const { t } = useTranslation();
  const pickupEstimate = formattedPickupEstimate ? addProperGrammarToEstimate(t, formattedPickupEstimate) : null;
  const deliveryEstimate = formattedDeliveryEstimate ? addProperGrammarToEstimate(t, formattedDeliveryEstimate) : null;
  const textProps = { pickupEstimate, deliveryEstimate };

  return (
    <Fragment>
      {(pickupEstimate || deliveryEstimate) && (
        <PrimaryText>
          {deliveryEstimate && pickupEstimate && <PickupAndDelivery {...textProps} />}
          {!deliveryEstimate && pickupEstimate && <OnlyPickup {...textProps} />}
          {deliveryEstimate && !pickupEstimate && <OnlyDelivery {...textProps} />}
        </PrimaryText>
      )}

      {storeHoursDeliveryOnly && (
        <SecondaryText>
          {t('closedBut.deliveryStoreHours', '*Delivery orders must be placed during store hours')}
        </SecondaryText>
      )}
    </Fragment>
  );
}

const Text = styled.div`
  font-size: 13px;
  line-height: 22px;
`;

const PrimaryText = styled(Text)`
  color: ${({ theme }) => theme.colors.grey[45]};
`;

const SecondaryText = styled(Text)`
  color: ${({ theme }) => theme.colors.grey[70]};
  margin-top: 10px;
`;
